export default __webpack_public_path__ + "static/Geek-92aacdc89ad924d928107bb8415e28bf.png";